<header id="banner" role="banner">
  <ng-content select="lib-authentication-form"></ng-content>
  <div id="logo-pegase">
    <img alt="Logo Pégase" data-tfa="pegase_logo"
         src="assets/img/pegase_logo.png" />
  </div>
  <div id="background-image"></div>
  <div id="background-uniform"></div>

  <ng-content select="pegase-pave-explicatif"></ng-content>
</header>
